export default __webpack_public_path__ + "static/media/4.54922103.jpg";